import { OpaqueToken } from '@angular/core';

export const DATASTORE_CONFIG = new OpaqueToken('DatastoreConfig');



// WEBPACK FOOTER //
// ./src/app/@shared/datastore/datastore.config.ts